import { InjectionToken } from '@angular/core';

import {
  Overlay
} from '@angular/cdk/overlay';
import type {
  ScrollStrategy
} from '@angular/cdk/overlay';
import type { DropdownItemComponent } from './dropdown-item.component';

export type StrategyFunc = () => ScrollStrategy;

export const DROPDOWN_SCROLL_STRATEGY = new InjectionToken<StrategyFunc>('dropdownScrollStrategy');

export const DROPDOWN_SCROLL_STRATEGY_PROVIDER_FACTORY = (overlay: Overlay): StrategyFunc => (): ScrollStrategy => overlay.scrollStrategies.close({ threshold: 2 });

export const DROPDOWN_SCROLL_STRATEGY_PROVIDER = {
  provide: DROPDOWN_SCROLL_STRATEGY,
  deps: [Overlay],
  useFactory: DROPDOWN_SCROLL_STRATEGY_PROVIDER_FACTORY
};

export interface DropdownItemClickHandler<T> {
  onClick(item: DropdownItemComponent<T>): void;
}

export const DROPDOWN_ITEM_CLICKABLE = new InjectionToken<DropdownItemClickHandler<unknown>>('DropdownItemClickHandlerToken');
